module.exports = __webpack_public_path__ + "img/56.9ecf5f50.jpg";